import type { RuntimeConfigMap } from 'Models/uiConfig/requestTypes';

// `status.json` is authored on the server and expected to be a flat
// record of strings/numbers/booleans describing the running instance.
// We don't validate individual keys here because diagnostics should
// survive schema drift; we only reject shapes that obviously aren't
// records (arrays, null, primitives).
export function isServerStatusPayload(payload: unknown): payload is RuntimeConfigMap {
  return typeof payload === 'object' && payload !== null && !Array.isArray(payload);
}

export function getInstanceId(payload: unknown): string | undefined {
  return isServerStatusPayload(payload) && typeof payload.InstanceId === 'string' && payload.InstanceId
    ? payload.InstanceId
    : undefined;
}
